<template>
  <div class="force-logout-mask">
    <div class="force-logout-modal">
      <h2 class="title">您的链接已断开</h2>

      <p class="message">可能的原因如下：</p>

      <ol class="reason-list">
        <li>网络异常</li>
        <li>账号在其他地方登录</li>
      </ol>

      <button class="confirm-btn" @click="goToLogin">重新登录</button>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from '@/stores/viewStore'

const store = useViewStore()
function goToLogin() {
  window.location.reload()
}
</script>

<style scoped>
.force-logout-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.force-logout-modal {
  width: 80vmin;
  padding: 5vmin;
  background: #ffffff;
  border-radius: 2vmin;
  box-shadow: 0 0 2vmin rgba(0, 0, 0, 0.4);
  text-align: center;
}

.title {
  font-size: 5vmin;
  font-weight: bold;
  margin-bottom: 3vmin;
  color: #d64541;
}

.message {
  font-size: 4vmin;
  color: #444;
  margin-bottom: 2vmin;
}

.reason-list {
  margin: 0 auto 5vmin;
  padding-left: 6vmin;
  width: fit-content;
  text-align: left;
  font-size: 4vmin;
  color: #444;
  line-height: 1.4;
}

.confirm-btn {
  font-size: 4vmin;
  padding: 2vmin 5vmin;
  background: #d64541;
  color: white;
  border: none;
  border-radius: 1vmin;
  cursor: pointer;
}
</style>
